import {useMaterials, Material} from '@domain/materials'

import {useUrlParam} from '../../../routing'

export const useMaterialsById = () => {
  const plantCode = useUrlParam('plantCode')
  return useMaterials<Record<string, Material>>({
    plantCode,
    options: {
      select: (data) =>
        data.reduce(
          (materialsById, material) => ({...materialsById, [String(material.id)]: material}),
          {} as Record<string, Material>
        )
    }
  })
}
